module.exports = __webpack_public_path__ + "static/img/settledPlatform.4ff611a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/settledPlatform.png
// module id = cmt+
// module chunks = 18